import { styled } from '@material-ui/core';

export const LoginRegisterCont = styled('div')(({ theme }) => ({
  padding: 20,
  display: 'flex',
  flexDirection: 'column',
  gap: 20,
  [theme.breakpoints.down('sm')]: {
    gap: 30,
  },
  '& svg': {
    width: '50px',
    height: '50px',
    alignSelf: 'center',
  },
}));

export const ButtonWrapper = styled('div')(({ theme }) => ({
  display: 'flex',
  gap: 20,
  [theme.breakpoints.down('sm')]: {
    flexDirection: 'column',
    gap: 10,
  },
}));
